"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const graphql_1 = require("../../../../graphql");
const react_use_1 = require("react-use");
const react_hooks_1 = require("@apollo/react-hooks");
const useFilter_1 = require("./useFilter");
exports.DEBOUNCE = 1000;
exports.useProxy = ({ contentFeed, contentMapping, }) => {
    const [failedToParse, toggleFailedToParse] = react_use_1.useToggle(false);
    const sharedJsonViewProps = {
        collapsed: 5,
        collapseStringsAfterLength: 50,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        groupArraysAfterLength: 3,
        iconStyle: 'triangle',
        indentWidth: 1,
        name: null,
        shouldCollapse: ({ type, src }) => {
            return type === 'array' && Array.isArray(src) && src.length > 10;
        },
        style: {
            fontSize: 11,
        },
    };
    const [mutateProxy, proxyResult] = react_hooks_1.useMutation(graphql_1.proxy, {
        variables: {
            contentFeedId: contentFeed && contentFeed.id,
        },
    });
    react_1.useEffect(() => {
        if (contentFeed) {
            mutateProxy();
        }
    }, [contentFeed, mutateProxy]);
    const { filteredContentItems, parseError, cancelFilter, filterIsPending, } = useFilter_1.useFilter({
        contentMapping,
        proxyResult,
        toggleFailedToParse,
    });
    return {
        cancelFilter,
        failedToParse,
        filteredContentItems,
        filterIsPending,
        mutateProxy,
        parseError,
        proxyResult,
        sharedJsonViewProps,
        toggleFailedToParse,
    };
};
//# sourceMappingURL=useProxy.js.map